import axios from '@/utils/request'
import base from '../base'


export function roleList(data) {
  return axios.get(`${base.url}/auth/role/list?pageSize=${data.pageSize}&pageNum=${data.pageNum}`);
}
export function roleListAll() {
  return axios.get(`${base.url}/auth/role/listAll`);
}
export function roleListAllByCompany(data) {
  return axios.get(`${base.url}/auth/role/listAll?companyId=${data.companyId}&modelId=${data.modelId}`);
}
export function editRoleList(data) {
  return axios.post(`${base.url}/auth/role/edit`, JSON.stringify(data),{ headers: {'Content-Type': 'application/json'}});
}
export function addRoleList(data) {
  return axios.post(`${base.url}/auth/role/save`, JSON.stringify(data),{ headers: {'Content-Type': 'application/json'}});
}
export function delRoleList(id) {
  return axios.get(`${base.url}/auth/role/del?id=${id}`);
}
export function recuRoleList(id) {
  return axios.get(`${base.url}/auth/menus/roleList?roleId=${id}`);
}
export function editRolePer(data) {
  return axios.post(`${base.url}/auth/menus/editRolePer`,JSON.stringify(data),{ headers: {'Content-Type': 'application/json'}});
}
export function getRoleColumnAuthInfo(data) {
  return axios.post(`${base.url}/auth/roleColumnAuth/getRoleColumnAuthInfo`,JSON.stringify(data),{ headers: {'Content-Type': 'application/json'}});
}
export function editRoleColumnAuth(data) {
  return axios.post(`${base.url}/auth/roleColumnAuth/edit`, JSON.stringify(data),{ headers: {'Content-Type': 'application/json'}});
}
export function addRoleColumnAuth(data) {
  return axios.post(`${base.url}/auth/roleColumnAuth/save`, JSON.stringify(data),{ headers: {'Content-Type': 'application/json'}});
}
